/**
 * Marcas de la franja institucional, en el orden que fija el documento de home.
 *
 * Son los logos oficiales que entregó diseño, optimizados a WebP por
 * `scripts/optimize-assets.js`. No se recrean con tipografía: cada uno es su
 * archivo original recortado y reescalado.
 */
export const brands = [
	{ name: "Hidracolor", logo: "/assets/logos/hidracolor.webp" },
	{ name: "Küül", logo: "/assets/logos/kuul.webp" },
	{ name: "Exel", logo: "/assets/logos/exel.webp" },
	{ name: "WMARK", logo: "/assets/logos/wmark.webp" },
	{ name: "Dompel", logo: "/assets/logos/dompel.webp" },
	{ name: "Bluesky", logo: "/assets/logos/bluesky.webp" },
	{ name: "Depilflax", logo: "/assets/logos/depilflax.webp" },
	{ name: "Starpil", logo: "/assets/logos/starpil.webp" },
	{ name: "Razorline", logo: "/assets/logos/razorline.webp" }
];

export default brands;
